import React from "react";

/**
 * Componente de Spinner con borde
 * 
 * @returns {JSX.Element} Componente de React
 */
const BorderSpinner = () => {
  return (
    <div className="text-center my-1">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Cargando...</span>
      </div>
    </div>
  );
};

export default BorderSpinner;
